import axios from 'axios'
import qs from 'qs'
import router from './router'
import {config} from './config'

axios.interceptors.request.use(function (config) {
    let token = localStorage.getItem("token");
    if (token == undefined) {
        token = "";
    }
    config.headers.Authorization = "Bearer "+token;
    return config;
}, function (error) {
    return console.log(error);
});

axios.interceptors.response.use(res => {
    return res;
  }, (err) => {
    if(err.response.status==401){
        localStorage.removeItem("token");
        router.push("/login")
    }else{
        console.log(err.response.status)
    }
})
export const uri = config.server;

// export const uri = "http://localhost:5000";
// export const uri = "http://api.dl.baomai.cc";
// export const uri = "http://api.gmagent.baomai.cc";


export const memberLoginReq = (params, callback) => externalGet(config.merchantApiServer+'/Member/Login', params, callback);

// export const memberLoginReq = (params, callback) => externalGet('http://api.c.baomai.cc/Member/Login', params, callback);

//代理
export const agentGetPanelReq = (params, callback) => get('/agent/GetPanel', params, callback);
export const agentSetConfigReq = (params, callback) => get('/agent/SetConfig', params, callback);

export const agentGetRecordReq = (params, callback) => get('/agent/GetRecord', params, callback);
export const agentGetMyReq = (params, callback) => get('/agent/GetMy', params, callback);
export const agentGetIndex = (params, callback) => get('/agent/GetIndex', params, callback);
export const agentWithdrawReq = (params, callback) => get('/record/Withdraw', params, callback);
export const agentGetFundsReq = (params, callback) => get('/record/GetFunds', params, callback);
export const agentGetTotalReq = (params, callback) => get('/record/GetTotal', params, callback);

export const agentGetSelReq = (params, callback) => get('/agent/GetSel', params, callback);

export const agentAddReq = (params, callback) => post('/agent/add', params, callback);
export const agentGetReq = (params, callback) => get('/agent/get', params, callback);
export const agentSetCommissionReq = (params, callback) => get('/agent/SetCommission', params, callback);
export const agentSetNameReq = (params, callback) => get('/agent/SetName', params, callback);
export const agentGetIdReq = (params, callback) => get('/agent/GetId', params, callback);
export const agentCanDeductionReq = (params, callback) => get('/agent/CanDeduction', params, callback);

export const agentSetPassWordReq = (params, callback) => get('/agent/SetPassWord', params, callback);

export const agentGetLeaderReq = (params, callback) => get('/agent/GetLeader', params, callback);
export const agentAddLeaderReq = (params, callback) => get('/agent/AddLeader', params, callback);
export const agentSetDisableReq = (params, callback) => get('/agent/SetDisable', params, callback);
export const agentSetInvitationCodeReq = (params, callback) => get('/agent/SetInvitationCode', params, callback);
export const agentGetTargetReq = (params, callback) => get('/agent/GetTarget', params, callback);
export const agentTransferReq = (params, callback) => get('/agent/Transfer', params, callback);


//报表
export const taskGetShopReportDownloadReq = (params, callback) => get('/task/GetShopReportDownload', params, callback);
export const taskGetMemberReportDownloadReq = (params, callback) => get('/task/GetMemberReportDownload', params, callback);
export const taskGetGoodsReportDownloadReq = (params, callback) => get('/task/GetGoodsReportDownload', params, callback);

//用户相关
export const loginReq = (params, callback) => get('/agent/login', params, callback);
export const memberGetReq = (params, callback) => get('/member/Get', params, callback);
export const memberAddReq = (params, callback) => post('/member/add', params, callback);

export const memberSetCommissionReq = (params, callback) => get('/member/SetCommission', params, callback);
export const memberSavePraiseCostReq = (params, callback) => post('/member/SavePraiseCost', params, callback);
export const memberSetRemarkReq = (params, callback) => get('/member/SetRemark', params, callback);
export const memberSetNameReq = (params, callback) => get('/member/SetName', params, callback);
export const memberGetArrearsReq = (params, callback) => get('/member/GetArrears', params, callback);
export const memberGetCollectionReq = (params, callback) => get('/member/GetCollection', params, callback);
export const memberRechargeReq = (params, callback) => post('/member/Recharge', params, callback);
export const memberSetPayTypeReq = (params, callback) => get('/member/SetPayType', params, callback);
export const memberGetMemberRefundReq = (params, callback) => get('/member/GetMemberRefund', params, callback);
export const memberRechargeUseBalanceReq = (params, callback) => post('/member/RechargeUseBalance', params, callback);
export const memberCloseCreditsReq = (params, callback) => get('/member/CloseCredits', params, callback);
export const memberOpenCreditsReq = (params, callback) => get('/member/OpenCredits', params, callback);
//店铺
export const shopGetReq = (params, callback) => get('/shop/Get', params, callback);
export const shopSetShopConfigReq = (params, callback) => get('/shop/SetShopConfig', params, callback);
export const shopSetChaQiReq = (params, callback) => get('/shop/SetChaQi', params, callback);
export const shopTestChaQiReq = (params, callback) => get('/shop/TestChaQi', params, callback);
//计划
export const taskGetReq = (params, callback) => get('/task/Get', params, callback);
export const taskGetDetailReq = (params, callback) => get('/task/GetDetail', params, callback);
export const taskTopReq = (params, callback) => get('/task/Top', params, callback);
export const taskGetPlanStatisticsReq = (params, callback) => get('/task/GetPlanStatistics', params, callback);
//任务
export const orderGetReq = (params, callback) => get('/order/Get', params, callback);
export const orderGetProcessReq = (params, callback) => get('/order/GetProcess', params, callback);

export const orderGetPraiseReq = (params, callback) => get('/order/GetPraise', params, callback);
export const orderReallocateReq = (params, callback) => get('/order/Reallocate', params, callback);
export const orderReallocateFundsReq = (params, callback) => get('/order/ReallocateFunds', params, callback);


export const orderGetOutsideCashierFundsReq = (params, callback) => get('/order/GetOutsideCashierFunds', params, callback);
export const orderGetOkOutsideCashierFundsReq = (params, callback) => get('/order/GetOkOutsideCashierFunds', params, callback);
export const orderGetHtOutsideCashierFundsReq = (params, callback) => get('/order/GetHtOutsideCashierFunds', params, callback);

export const orderLockReq = (params, callback) => get('/order/Lock', params, callback);
export const orderCompletePayReq = (params, callback) => get('/order/CompletePay', params, callback);
export const orderGetOkOutsideCashierFundsTotalReq = (params, callback) => get('/order/GetOkOutsideCashierFundsTotal', params, callback);
//售后
export const orderCancelUndoReq = (params, callback) => get('/order/CancelUndo', params, callback);
export const orderGetUndoOkListReq = (params, callback) => get('/order/GetUndoOkList', params, callback);
export const orderUndoReq = (params, callback) => get('/order/Undo', params, callback);
export const orderGetUndoListReq = (params, callback) => get('/order/GetUndoList', params, callback);

export const orderGetStatisticsReq = (params, callback) => get('/order/GetStatistics', params, callback);
export const orderUnlockReq = (params, callback) => get('/order/Unlock', params, callback);

//佣金
export const commissionGetAllReq = (params, callback) => get('/Commission/GetAll', params, callback);
export const commissionGetDetailReq = (params, callback) => get('/Commission/GetDetail', params, callback);
export const commissionGetReq = (params, callback) => get('/Commission/Get', params, callback);
export const commissionAddReq = (params, callback) => post('/Commission/Add', params, callback);


//商品
export const goodsGetReq = (params, callback) => get('/goods/Get', params, callback);
export const goodsUpdateReq = (params, callback) => post('/goods/Update', params, callback);
export const goodsGetInfoByUrlReq = (params, callback) => get('/goods/GetInfoByUrl', params, callback);


export const externalGet = (api, params, callback) => axios.get(api, {
    params: params
}).then(res => {
    callback(res.data);
});

export const get = (api, params, callback) => axios.get(uri + api, {
    params: params
}).then(res => {
    callback(res.data);
});

export const post = (api, params, callback) => axios.post(uri + api, qs.stringify(params))
.then(res => {
        callback(res.data);
});

///上传文件
export const postFile = (api, file, callback) => axios.post(uri + api, file,{'Content-type' : 'multipart/form-data'})
.then(res => {
    callback(res.data);
});

// 客户端直传：向后端要预签名地址，再用 fetch 直接 PUT 到 MinIO，返回公网可读 URL
export const directUpload = async (fileObj) => {
    let ext = "jpg";
    const name = fileObj.name || "";
    const dot = name.lastIndexOf(".");
    if (dot >= 0 && dot < name.length - 1) {
        ext = name.substring(dot + 1).toLowerCase();
    }
    const presign = (await axios.get(uri + "/Oss/Presign", { params: { ext } })).data;
    if (!presign || !presign.IsSuccess || !presign.putUrl) {
        throw new Error("获取上传地址失败");
    }
    // 用原生 fetch，避免 axios 拦截器塞 Bearer 头破坏 S3 签名
    const putRes = await fetch(presign.putUrl, {
        method: "PUT",
        body: fileObj,
        headers: { "Content-Type": fileObj.type || "application/octet-stream" },
    });
    if (!putRes.ok) {
        throw new Error("上传失败:" + putRes.status);
    }
    return presign.publicUrl;
};

// ant-design-vue <a-upload> 的 custom-request：拦截默认 multipart 上传，改成客户端直传。
// 成功后把 file.response 置为 {IsSuccess:true, Message: 公网URL}，与原后端返回结构一致，下游读取逻辑无需改动。
export const ossDirectUpload = (options) => {
    directUpload(options.file)
        .then((url) => {
            options.onSuccess({ IsSuccess: true, Message: url }, options.file);
        })
        .catch((err) => {
            options.onError(err);
        });
};

